import * as Sentry from "@sentry/react"
const errorList : Array<Sentry.ErrorEvent> = []
export default errorList;